import { QuestionType } from "api/landlord-surveys/types/questions";
import { ReactNode } from "react";
import { TextArea } from "shared/components/forms/TextArea";
import {
  useSurveyStore,
  selectActiveQuestion
} from "views/landlord-surveys-id/store";
import { DateWidget } from "./date-widget";
import { FileWidget } from "./file-widget";
import { YesNoWidget } from "./yes-no-widget";
import { LongTextWidget } from "./long-text-widget";
import { MultiselectWidget } from "./multiselect-widget";
import { RadioWidget } from "./radio-widget";

const TitleField = () => {
  const activeQuestion = useSurveyStore(selectActiveQuestion);
  const updateActiveQuestion = useSurveyStore(
    (state) => state.updateActiveQuestion
  );

  return (
    <TextArea
      id="title"
      autoFocus
      value={activeQuestion?.question}
      onChange={(e) => {
        updateActiveQuestion((prev) => ({
          ...prev,
          question: e.target.value
        }));
      }}
      legacyErrorMargins={false}
      placeholder="Type your question here"
      className=" text-xl !shadow-none !focus:shadow-none !p-0 !placeholder:font-medium placeholder:text-content-400 placeholder:text-xl border-none outline-none focus:outline-none"
      autoExpand
      rows={1}
      maxLength={350}
      max={4}
    />
  );
};

const DescriptionField = () => {
  const activeQuestion = useSurveyStore(selectActiveQuestion);
  const updateActiveQuestion = useSurveyStore(
    (state) => state.updateActiveQuestion
  );
  return (
    <TextArea
      id="description"
      value={activeQuestion?.description}
      onChange={(e) => {
        updateActiveQuestion((prev) => ({
          ...prev,
          description: e.target.value
        }));
      }}
      placeholder="Description (optional)"
      className="text-sm text-content-500 !shadow-none !focus:shadow-none !p-0 !placeholder:font-medium placeholder:text-content-200 placeholder:text-sm border-none outline-none focus:outline-none"
      autoExpand
      rows={1}
      maxLength={350}
      max={4}
      legacyErrorMargins={false}
    />
  );
};

const QuestionWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <fieldset>
      <TitleField />
      <DescriptionField />

      {children}
    </fieldset>
  );
};
const WidgetMap = () => {
  const activeQuestion = useSurveyStore(selectActiveQuestion);

  switch (activeQuestion?.type) {
    case QuestionType.CHECKBOX_MULTI:
      return <MultiselectWidget />;
    case QuestionType.RADIO_GROUP:
      return <RadioWidget />;
    case QuestionType.ADDRESS:
    case QuestionType.DATE:
      return <DateWidget />;
    case QuestionType.FILE_SINGLE:
      return <FileWidget />;
    case QuestionType.YES_NO:
      return <YesNoWidget />;
    case QuestionType.LONG_TEXT:
      return <LongTextWidget />;
  }
};

export const Widget = () => {
  return (
    <QuestionWrapper>
      <WidgetMap />
    </QuestionWrapper>
  );
};
